import { useCurrentUser } from "@radarly/core/user/use-cases";
import { getVisibleBannerFromRole } from "@radarly/models/banner";
import { useContextualProjectUserRole } from "./useContextualProjectUserRole";

export function useVisibleBanner() {
  return getVisibleBannerFromRole(
    useCurrentUser().banners,
    useContextualProjectUserRole()
  );
}
